// extracted by mini-css-extract-plugin
module.exports = {"form":"RegisterPage_form__FDAQk","link":"RegisterPage_link__2Zqut"};